"use strict";

var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
      r,
      ar = [],
      e;

  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) {
      ar.push(r.value);
    }
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }

  return ar;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useMediaQueryLayout = exports.useMediaQuery = void 0;

var react_1 = require("react");

var literal_case_1 = require("./literal-case");

function noop() {}

function queryObjectToString(query) {
  if (typeof query === 'string') {
    return query;
  }

  return Object.entries(query).map(function (_a) {
    var _b = __read(_a, 2),
        feature = _b[0],
        value = _b[1];

    var convertedFeature = (0, literal_case_1.kebabCase)(feature);
    var convertedValue = value;

    if (typeof convertedValue === 'boolean') {
      return convertedValue ? convertedFeature : "not " + convertedFeature;
    }

    if (typeof convertedValue === 'number' && /[height|width]$/.test(convertedFeature)) {
      convertedValue = convertedValue + "px";
    }

    return "(" + convertedFeature + ": " + convertedValue + ")";
  }).join(' and ');
}

var mockMediaQueryList = {
  media: '',
  matches: false,
  onchange: noop,
  addListener: noop,
  removeListener: noop,
  addEventListener: noop,
  removeEventListener: noop,
  dispatchEvent: function dispatchEvent(_) {
    return true;
  }
};

var createUseMedia = function createUseMedia(effect) {
  return function (rawQuery, defaultState) {
    if (defaultState === void 0) {
      defaultState = false;
    }

    var _a = __read((0, react_1.useState)(defaultState), 2),
        state = _a[0],
        setState = _a[1];

    var query = queryObjectToString(rawQuery);
    effect(function () {
      var mounted = true;
      var mediaQueryList = typeof window === 'undefined' ? mockMediaQueryList : window.matchMedia(query);

      var onChange = function onChange() {
        if (!mounted) {
          return;
        }

        setState(Boolean(mediaQueryList.matches));
      };

      mediaQueryList.addEventListener('change', onChange);
      setState(mediaQueryList.matches);
      return function () {
        mounted = false;
        mediaQueryList.removeEventListener('change', onChange);
      };
    }, [query]);
    return state;
  };
};

exports.useMediaQuery = createUseMedia(react_1.useEffect);
exports.useMediaQueryLayout = createUseMedia(react_1.useLayoutEffect);